import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");

// Example
const AllCharts = () => import("@/components/chart/chart");

// Views - Components
const Tables = () => import("@/views/base/Tables");
const MapByState = () => import("@/views/base/MapState");
const BER = () => import("@/views/base/BeyondEconomicalRepair.vue");
const EOL = () => import("@/views/base/EndOfLife.vue");
const WAR = () => import("@/views/base/UnderWarranty.vue");
const Map = () => import("@/views/base/MapOverview.vue");
const City = () => import("@/views/base/CityProfile.vue");
const AnalyticsByModel = () => import("@/views/base/AnalyticsByModel.vue");
const Received = () => import("@/views/base/Received.vue");
const ModelView = () => import("@/views/base/ModelProfile");
const BacklogByLocation = () => import("@/views/base/BacklogByLocation");
const Profile = () => import("@/views/base/ProfileSettings.vue");
const ActiveBacklog = () => import("@/views/base/ActiveBacklog")
// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");

// Table All Data
const OverallData = () => import ("@/views/base/OverallData.vue");
const TableAllData = () => import("@/views/base/TableAllData.vue");

// CompanyProfile
const CompanyProfile = () => import("@/views/base/CompanyProfile.vue");

// Issues
const IssuePreview = () => import ("@/views/base/IssuePreview.vue");
const IssueMap = () => import ("@/views/base/IssueMap.vue");

// Failure Data
const FailureDetails = () => import("@/views/base/FailureDetailsTable.vue");

// Search
const Search = () => import("@/views/base/Search.vue");

// To Do
const TodoList = () => import("@/views/base/TodoList.vue");
const TodoListDetails = () => import("@/views/base/TodoListDetails.vue");

Vue.use(Router);

export default new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard
        },
        {
          path: "search",
          name: "Search Form",
          component: Search,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "base/company-profile",
          name: "Company Profile",
          component: CompanyProfile,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "/failure-details",
          name: "Failure Details",
          component: FailureDetails,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "base/backlog-by-location",
          name: "Backlog By Location",
          component:  BacklogByLocation
        },
        {
          path: "base/IssuesPreview",
          name: "Issues Preview",
          component:  IssuePreview
        },
        {
          path: "base/IssuesMap",
          name: "Map By Region",
          component:  IssueMap
        },
        {
          path: "AllCharts",
          name: "AllCharts",
          component: AllCharts
        },
        {
          path: "analyticsByModel",
          name: "AnalyticsByModel",
          component: AnalyticsByModel
        },
        {
          path: "activeBacklog",
          name: "ActiveBacklog",
          component:  ActiveBacklog
        },
        {
          path: "Received",
          name: "Received Equipment",
          component: Received
        },

        {
          path: "base/overall",
          name: "Overall Data",
          component: OverallData
        },
        {
          path: "model",
          name: "Model",
          component: ModelView,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "profile",
              name: "Profile Settings",
              component: Profile
            },
            {
              path: "BER",
              name: "BER",
              component: BER
            },
            {
              path: "EOL",
              name: "EOL",
              component: EOL
            },
            {
              path: "WAR",
              name: "WAR",
              component: WAR
            },
            {
              path: "Map",
              name: "Map Overview",
              component: Map
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "TableAllData",
              name: "TableAllData",
              component: TableAllData,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "city",
              name: "City",
              component: City,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "MapByState",
              name: "MapByState",
              component: MapByState,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "TodoList",
              name: "TodoList",
              component: TodoList
            },
            {
              path: "TodoList-Details",
              name: "TodoListDetails",
              component: TodoListDetails,
              props(route) {
                return route.query || {};
              }
            },
          ]
        },
      ]
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "500",
          name: "Page500",
          component: Page500
        },
        {
          path: "login",
          name: "Login",
          component: Login,
          props(route) {
            return route.query || {};
          }
        },
      ]
    }
  ]
});
